/**
* this is the app layout with the TopBar, Left & right Side Menu,
* Content area and footer
*
* Created by Tom on 23/5/17
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import cx from 'classnames'
import { withRouter } from 'react-router-dom'


// action import
import { ActionCreator } from '../../actions/'

// routes import
// NOTE: all components that uses `Routes` need to be wrapped with `withRouter()`
import Routes from '../../routes'

// components
import TopBar from '../../components/TopBar/'
import Overlay from '../../components/Overlay/'
import LeftMenu from '../../components/LeftMenu/'
import RightMenu from '../../components/RightMenu/'
import Footer from '../../components/Footer/'

import Tour from '../../components/Tour/'

// style import
import './style.scss'

class MemberArea extends Component {

    componentWillMount() {
        const { getProfileData } = this.props

        getProfileData()
    }

    componentDidMount() {
        const { breakPointObj, setOpenRightMenu } = this.props

        // set the right menu to open for desktop view
        if(breakPointObj.greaterThan.medium)
            setOpenRightMenu(true)
    }

    render() {

        const { breakPointObj, openRightMenu } = this.props
 
        // member-area classes based on the truthy value 'openRightMenu'
        const dynClass = cx('member-area', {'right-menu-open': openRightMenu})

        return (
            <div className={dynClass}>

                {/* top bar component */}
                <TopBar />

                {/* body element that contains the overlay, menus & footer */}
                <div className="body-container">

                    {/* overlay component (only show on tablet and mobile)*/}
                    {
                        (breakPointObj.lessThan.large && <Overlay />)
                    }

                    {/* routing happens only in the main area */}
                    <div className="main"><Routes/></div>

                    {/* left menu component */}
                    <LeftMenu />

                    {/* right menu component */}
                    <RightMenu />

                    {/* footer component (only show on tablet)*/}
                    {
                        (breakPointObj.lessThan.large && <Footer />)
                    }

                </div>

                {/* Tour component */}
                <Tour />

            </div>
        )
    }
}

// define the prop types
MemberArea.propTypes = {
    breakPointObj: PropTypes.object,
    getProfileData: PropTypes.func.isRequired,
}

// pull props to this container
const mapStateToProps = (state) => {
    return {
        breakPointObj: state.browser,
        openRightMenu: state.componentState.openRightMenu,
    }
}

// pull all required action creators into this container
const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        setOpenRightMenu: action.setOpenRightMenu,
        getProfileData: action.getProfileData,
    }
}
/*
    you can get access to the history object's properties and the closest
    <Route>'s match via the `withRouter` higher-order component. `withRouter`
    will pass updated match, location, and history props to the wrapped
    component whenever it renders.
*/
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MemberArea))



// WEBPACK FOOTER //
// ./src/components/MemberArea/index.js